precision highp float;
#define GLSLIFY 1

varying vec2 v_texcoord;
uniform sampler2D u_texture_1;
uniform sampler2D u_texture_2;
uniform float u_alpha;
uniform float u_img_fade;
uniform float u_img_scale;

void main() {
    vec2 coords2 = vec2(-0.5, -0.5) + v_texcoord;
    coords2 = vec2(u_img_scale, u_img_scale) * coords2;
    coords2 = vec2(0.5, 0.5) + coords2;
    vec4 color2 = texture2D(u_texture_2, coords2);

    vec4 color = color2;

    if (u_img_fade > -1.0){
        vec2 coords1 = vec2(-0.5, -0.5) + v_texcoord;
        coords1 = vec2(0.95, 0.95) * coords1;
        coords1 = vec2(0.5, 0.5) + coords1;
        vec4 color1 = texture2D(u_texture_1, coords1);

        color = mix(color1, color2, u_img_fade);
    }

    gl_FragColor = vec4(color.rgb, color.a * u_alpha);
}